module.exports = __webpack_public_path__ + "static/media/keeano-icon.1a28024a.svg";